
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fullDeliverySummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MessageReadSummary"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"messageUuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"messageType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recipientCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveredEntry"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullPreciseSummaryEntry"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullEstimatedSummaryEntry"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"readEntry"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullPreciseSummaryEntry"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullEstimatedSummaryEntry"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"failedEntry"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullPreciseSummaryEntry"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullEstimatedSummaryEntry"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"unreachableEntry"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullPreciseSummaryEntry"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullEstimatedSummaryEntry"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"identificationErrorEntry"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullPreciseSummaryEntry"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullEstimatedSummaryEntry"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"downloadAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"downloadAvailableUntil"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":792}};
    doc.loc.source = {"body":"#import \"chat/fragments/fullEstimatedSummaryEntryFragment.gql\"\n#import \"chat/fragments/fullPreciseSummaryEntryFragment.gql\"\n\nfragment fullDeliverySummary on MessageReadSummary {\n  state\n  messageUuid\n  messageType\n  recipientCount\n  deliveredEntry {\n    __typename\n    ...fullPreciseSummaryEntry\n    ...fullEstimatedSummaryEntry\n  }\n  readEntry {\n    __typename\n    ...fullPreciseSummaryEntry\n    ...fullEstimatedSummaryEntry\n  }\n  failedEntry {\n    __typename\n    ...fullPreciseSummaryEntry\n    ...fullEstimatedSummaryEntry\n  }\n  unreachableEntry {\n    __typename\n    ...fullPreciseSummaryEntry\n    ...fullEstimatedSummaryEntry\n  }\n  identificationErrorEntry {\n    __typename\n    ...fullPreciseSummaryEntry\n    ...fullEstimatedSummaryEntry\n  }\n  downloadAvailable\n  downloadAvailableUntil\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("chat/fragments/fullEstimatedSummaryEntryFragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("chat/fragments/fullPreciseSummaryEntryFragment.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["fullDeliverySummary"] = oneQuery(doc, "fullDeliverySummary");
        
